import {
  API_ENVIRONMENT_STORAGE_KEY,
  API_ENVIRONMENT_URLS,
  readStoredApiEnvironment
} from "@/data_source/constants/apiEnvironment";
import type { ApiEnvironmentId } from "@/data_source/constants/apiEnvironment";

export function getEnvVariable<T = any>(window: Partial<Window>) {
  return function (
    localName: string,
    envName: string
  ): T | boolean | undefined {
    const hasProperty = Object.prototype.hasOwnProperty.call(
      window,
      `${localName}`
    );
    if (!hasProperty)
      return import.meta.env[`VITE_APP_${envName}`] as T | undefined;
    const envValue = (window as { [key: string]: any })[`${localName}`];
    if (`${envValue}`.match(RegExp("true", "i"))) return true;
    if (`${envValue}`.match(RegExp("false", "i"))) return false;
    if (`${envValue}`.match(RegExp("^[a-zA-Z0-9]+"))) return envValue;
    return import.meta.env[`VITE_APP_${envName}`] as T | undefined;
  };
}

export const ENABLE_API_ENV_SELECTOR =
  getEnvVariable<boolean>(window)(
    "ENABLE_API_ENV_SELECTOR",
    "ENABLE_API_ENV_SELECTOR"
  ) || false;

function configuredApiBaseUrl(): string {
  return (
    (getEnvVariable(window)("APP_API_BASE_URL", "BASE_URL") as string) || ""
  );
}

function resolveAppApiBaseUrl(): string {
  if (!ENABLE_API_ENV_SELECTOR) return configuredApiBaseUrl();
  const stored = readStoredApiEnvironment();
  if (!stored) return configuredApiBaseUrl();
  return API_ENVIRONMENT_URLS[stored];
}

export let APP_API_BASE_URL = resolveAppApiBaseUrl();

export function setAppApiBaseUrl(url: string): void {
  APP_API_BASE_URL = url;
}

export function applySelectedApiEnvironment(id: ApiEnvironmentId): void {
  localStorage.setItem(API_ENVIRONMENT_STORAGE_KEY, id);
  setAppApiBaseUrl(API_ENVIRONMENT_URLS[id]);
}

export const ENABLE_POLL_DELETE =
  getEnvVariable<boolean>(window)("ENABLE_POLL_DELETE", "ENABLE_POLL_DELETE") ||
  true;

export const REDIRECT_TO_SAME_DOMAIN_AFTER_LOGIN =
  getEnvVariable<boolean>(window)(
    "REDIRECT_TO_SAME_DOMAIN_AFTER_LOGIN",
    "REDIRECT_TO_SAME_DOMAIN_AFTER_LOGIN"
  ) || false;

export const WEB_VERSION =
  (getEnvVariable(window)("WEB_VERSION", "WEB_VERSION") as string) || "1.0.0";

export const YEAR_VERSION =
  (getEnvVariable(window)("YEAR_VERSION", "YEAR_VERSION") as string) || "";
export const GOOGLEMAP_API_KEY = getEnvVariable(window)(
  "GOOGLEMAP_API_KEY",
  "GOOGLEMAP_API_KEY"
) as string;
export const LOCALHOST =
  (getEnvVariable<boolean>(window)("LOCALHOST", "LOCALHOST") as boolean) ||
  false;
export const FIREBASE_APIKEY = getEnvVariable(window)(
  "FIREBASE_APIKEY",
  "FIREBASE_APIKEY"
) as string;
export const FIREBASE_AUTHDOMAIN = getEnvVariable(window)(
  "FIREBASE_AUTHDOMAIN",
  "FIREBASE_AUTHDOMAIN"
) as string;
export const FIREBASE_PREOJECTID = getEnvVariable(window)(
  "FIREBASE_PREOJECTID",
  "FIREBASE_PREOJECTID"
) as string;
export const FIREBASE_STORAGEBUCKET = getEnvVariable(window)(
  "FIREBASE_STORAGEBUCKET",
  "FIREBASE_STORAGEBUCKET"
) as string;
export const FIREBASE_MESSAGSENDINGID = getEnvVariable(window)(
  "FIREBASE_MESSAGSENDINGID",
  "FIREBASE_MESSAGSENDINGID"
) as string;
export const FIREBASE_APPID = getEnvVariable(window)(
  "FIREBASE_APPID",
  "FIREBASE_APPID"
) as string;
export const FIREBASE_MEASUREMENTID = getEnvVariable(window)(
  "FIREBASE_MEASUREMENTID",
  "FIREBASE_MEASUREMENTID"
) as string;
export const FIREBASE_VAPIDKEY = getEnvVariable(window)(
  "FIREBASE_VAPIDKEY",
  "FIREBASE_VAPIDKEY"
) as string;

export const CACHE_EXPIRATION_TIME = `${getEnvVariable(window)(
  "CACHE_EXPIRATION_TIME",
  "CACHE_EXPIRATION_TIME"
)}`.match(RegExp("^[0-9]+$"))
  ? Number(
      getEnvVariable(window)("CACHE_EXPIRATION_TIME", "CACHE_EXPIRATION_TIME")
    )
  : 0;

export const GEOSERVER_STORE = (function (): string {
  const location = window.location.hostname;
  const subDomain = location.split(".")[0] || "";
  return subDomain === "tmopr" ? "production" : subDomain;
})();
export const GEOSERVER_WMS_URL = `${window.location.origin}/geoserver/wms`;

export const NODE_ENV = process.env.NODE_ENV;

/** Global Photo Gallery vs legacy View media. */
export const ENABLE_ASSET_PHOTO_GALLERY =
  getEnvVariable<boolean>(window)(
    "ENABLE_ASSET_PHOTO_GALLERY",
    "ENABLE_ASSET_PHOTO_GALLERY"
  ) || false;
